/**
 * LanguageSelector component
 *
 * Simple language toggle between Serbian and English.
 */

import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks';

export function LanguageSelector() {
  const { t } = useTranslation();
  const { language, setLanguage } = useAuth();

  const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setLanguage(e.target.value);
  };

  return (
    <div className="language-selector">
      <select
        value={language}
        onChange={handleLanguageChange}
        className="language-select"
        data-testid="language-selector"
      >
        <option value="sr">{t('settings.serbian')}</option>
        <option value="en">{t('settings.english')}</option>
      </select>
    </div>
  );
}

export default LanguageSelector;
